import { render, staticRenderFns } from "./lowHealth.vue?vue&type=template&id=19b2b526&scoped=true&"
import script from "./lowHealth.vue?vue&type=script&lang=js&"
export * from "./lowHealth.vue?vue&type=script&lang=js&"
import style0 from "./lowHealth.vue?vue&type=style&index=0&id=19b2b526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2b526",
  null
  
)

export default component.exports